import { cn } from '@/frontend/lib/utils'

import type { FieldLayoutProps } from './form-layout-context'

/**
 * Stacked layout: Label → Description → Control → Error
 * Each element on its own row
 */
export function StackedLayout({ label, description, control, error, className }: FieldLayoutProps) {
  return (
    <div className={cn('flex min-w-0 flex-col gap-2', className)}>
      {(label || description) && (
        <div className="flex flex-col gap-0.5">
          {label}
          {description}
        </div>
      )}
      {control}
      {error}
    </div>
  )
}
